var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.846 268.431L73.8842 288.945C75.209 289.88 77.0382 288.933 77.0382 287.311V108.003C77.0382 106.445 75.3352 105.485 74.0023 106.292L44.9641 123.876C44.3656 124.238 44 124.887 44 125.587V266.797C44 267.447 44.3155 268.056 44.846 268.431Z",
    stroke: "#EA3377",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143 193.545V227.632C143.285 245.525 172.563 260 218 260C263.437 260 292.696 245.525 293 227.632V193.545H143Z",
    fill: "#68ADE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293 193.545C293 212.321 263.608 227.545 218 227.545C172.392 227.545 143 212.321 143 193.545C143 174.77 172.392 159.545 218 159.545C263.608 159.545 293 174.751 293 193.545Z",
    fill: "#472037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143 159.545V189.984C143.285 207.978 172.563 224.455 218 224.455C263.437 224.455 292.696 207.978 293 189.984V159.545H143Z",
    fill: "#93E54B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M293 158.772C293 177.975 263.608 193.545 218 193.545C172.392 193.545 143 177.975 143 158.772C143 139.57 172.392 124 218 124C263.608 124 293 139.551 293 158.772Z",
    fill: "#472037"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143 124V154.438C143.285 172.432 172.563 188.909 218 188.909C263.437 188.909 292.696 172.432 293 154.438V124H143Z",
    fill: "#FF005F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M293 124.773C293 143.975 263.608 159.545 218 159.545C172.392 159.545 143 143.975 143 124.773C143 105.57 172.392 90 218 90C263.608 90 293 105.551 293 124.773Z",
    fill: "#472037"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 43,
    width: 280,
    height: 263,
    rx: 20,
    stroke: "#EA3377",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.db90276cacc028ed50aa2b98aef8863c.svg";
export { ForwardRef as ReactComponent };